import { Component } from '@angular/core';

@Component({
  selector: 'fgb-facial-recognition-step',
  templateUrl: './facial-recognition-step.component.html',
  styleUrl: './facial-recognition-step.component.scss',
})
export class FacialRecognitionStepComponent {
  stepNumber = 1;
  isLast = false;
  isFirst = false;
  currentStep = 1;

  constructor() {}

  ngOnInit() {}
}
